import React from 'react';
import classnames from 'classnames';
import { TextField } from '@mui/material';
import SearchIcon from './icons/SearchIcon';

class AutoSizingSearchInput extends React.Component {
  state = {
    isFocused: false,
  };

  render() {
    const { searchText } = this.props;
    const { isFocused } = this.state;
    const isExpanded = isFocused || !!searchText;

    return (
      <TextField
        className={classnames('auto-sizing-search-input', {
          'is-expanded': isExpanded,
        })}
        value={searchText}
        variant="outlined"
        InputProps={{
          endAdornment: <SearchIcon style={{ flexShrink: 0, pointerEvents: 'none' }} />,
        }}
        inputProps={{
          autoComplete: 'new-password',
          style: {
            fontSize: 12,
            padding: isExpanded ? 6 : '6px 0 6px 6px',
          },
        }}
        onFocus={this._handleFocus}
        onBlur={this._handleBlur}
        onChange={this._handleChange}
      />
    );
  }

  _handleFocus = () => {
    this.setState({ isFocused: true });
  };

  _handleBlur = () => {
    this.setState({ isFocused: false });
  };

  _handleChange = (e) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(e.target.value);
    }
  };
}

export default AutoSizingSearchInput;
